import { getPatternStyles, patternFns } from './runtime.js';
import { memo } from '../helpers.js';
import { css } from '../css/index.js';

const commonScrollbarConfig = {
  transform(props) {
    const { horizontalScroll, ...rest } = props;
    return {
      "&::-webkit-scrollbar": {
        width: 8,
        height: horizontalScroll ? 8 : "auto"
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: 20,
        backgroundClip: "padding-box",
        border: "2px solid transparent",
        backgroundColor: "mui.primary.stroke"
      },
      ...rest
    };
  },
  defaultValues: { horizontalScroll: false }
}

export function commonScrollbarRaw(styles) {
  const s = getPatternStyles(commonScrollbarConfig, styles || {})
  return commonScrollbarConfig.transform(s, patternFns)
}

export const commonScrollbar = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function commonScrollbar(styles = {}) {
  return css(commonScrollbarRaw(styles))
}), { raw: commonScrollbarRaw, propKeys: ["horizontalScroll"] })